import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { useCustomerAuth } from "../../context/CustomerAuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useCustomerAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    (async () => {
      try {
        // Parse session_token and redirect from URL hash
        // e.g. /auth/callback#session_token=abc123&redirect=/account
        const hash = window.location.hash.replace("#", "");
        const hashParams = new URLSearchParams(hash);
        const sessionToken = hashParams.get("session_token");
        const redirectTo = hashParams.get("redirect") || localStorage.getItem("bcp_login_return") || "/account";
        localStorage.removeItem("bcp_login_return");

        if (sessionToken) {
          // Store session token in localStorage as fallback for cross-port local dev
          // In production the httpOnly cookie handles this automatically
          localStorage.setItem("bcp_session_token", sessionToken);
          // Also set it as a cookie manually for the API calls
          document.cookie = `session_token=${sessionToken}; path=/; max-age=${7 * 24 * 60 * 60}; samesite=lax`;
        }

        // Fetch user — cookie or manual cookie set above should work now
        const { data } = await api.get("/auth/me");
        setUser(data);
        navigate(redirectTo, { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || "Failed to complete sign in");
        setTimeout(() => navigate("/", { replace: true }), 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">Signing you in…</div>
        {error && <div className="mt-4 text-sm text-red-600">{error}</div>}
      </div>
    </div>
  );
}